const BaseModule = require('../../90_utils/base/BaseModule');

class LazyImg extends BaseModule {

	constructor(el, params) {

		super(el);

		this.currentURL;
		this.desktopURL;
		this.mobileURL;
	}

	// basemodule methods

	_domReady(){
		this._updateAttributes();
	}

	_updateAttributes(){
		this.desktopURL = this.$el.attr('data-desktop-src');
		this.mobileURL = this.$el.attr('data-mobile-src');
		this._resize();
	}

	_changeImage(imageURL){

		if(imageURL && this.currentURL !== imageURL){

			this.$el.removeClass('is-loaded');

			if(this.currentURL){
				this.$el.off('load', $.proxy(this._onLoaded, this));
				this.$el.triggerHandler('loadCanceled');
			}

			// let anyone who is listening know this image is about to change

			this.$el.triggerHandler('imageChange', {target:this, imageURL:imageURL});

			//

			this.currentURL = imageURL;
			this.$el.on('load', $.proxy(this._onLoaded, this));
			this.$el.attr('src', imageURL);
		}
	}

	_onLoaded(e){
		this.$el.off('load', $.proxy(this._onLoaded, this));
		this.$el.triggerHandler('load', {target:this, imageURL:this.currentURL, originalEvent:e});
		this.$el.addClass('is-loaded');
	}

	_addListeners(){ }
	_removeListeners(){ }

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){

		if(window.SETTINGS.breakpoint.minWidth('screen-phablet') && window.SETTINGS.breakpoint.minHeight('screen-phablet')){
			this._changeImage(this.desktopURL);
		}
		else {
			this._changeImage(this.mobileURL);
		}
	}
}

module.exports = LazyImg;
